<template>
  <grid-container-fi :container="false">
    <div
      class="product-family-accordions-fi fi-col-start-1 fi-col-end-13 lg:fi-col-start-2 lg:fi-col-end-12"
    >
      <accordion-benefits-description-fi :catalog-data="catalogData" />
      <accordion-application-authorisation-fi :catalog-data="catalogData" />
      <accordion-assembly-instructions-fi :catalog-data="catalogData" />
      <accordion-document-downloads-fi :catalog-data="catalogData" />
    </div>
  </grid-container-fi>
</template>

<script>
import setupAccordion from 'components/atoms/accordion/setupAccordion';
import AccordionApplicationAuthorisationFi from 'components/catalog-accordions/accordion-application-authorisation/AccordionApplicationAuthorisationFi';
import AccordionAssemblyInstructionsFi from 'components/catalog-accordions/accordion-assembly-instructions/AccordionAssemblyInstructionsFi';
import AccordionBenefitsDescriptionFi from 'components/catalog-accordions/accordion-benefits-description/AccordionBenefitsDescriptionFi';
import AccordionDocumentDownloadsFi from 'components/catalog-accordions/accordion-document-downloads/AccordionDocumentDownloadsFi';
import GridContainerFi from 'components/grid-fi/GridContainerFi';

export default {
  name: 'ProductFamilyAccordionFi',
  components: {
    AccordionBenefitsDescriptionFi,
    AccordionApplicationAuthorisationFi,
    AccordionAssemblyInstructionsFi,
    AccordionDocumentDownloadsFi,
    GridContainerFi,
  },
  props: {
    catalogData: {
      type: Object,
      default: () => ({}),
    },
  },
  setup() {
    setupAccordion();
  },
};
</script>

<style lang="scss">
@import './product-family-accordions-fi.scss';
</style>
